// RegisterViewModel.js
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { useMounted } from 'src/hooks/use-mounted';
import { startLoading, stopLoading } from 'src/utils/loading';
import { signUp } from './my-model';

const initialValues = {
  email: 'lorien@tc439.com',
  name: 'zombie',
  phone: '0932168077',
  policy: false,
  submit: null,
};

const validationSchema = Yup.object({
  email: Yup.string()
    .email('Must be a valid email')
    .max(255)
    .required('Email is required'),
  name: Yup.string().max(255).required('Name is required'),
  phone: Yup.string().min(10).max(11).required('Phone is required'),
  policy: Yup.boolean().oneOf([true], 'This field must be checked'),
});

const useViewModel = (onSuccess, onError) => {
  const isMounted = useMounted();
  const onSubmit = async (values, helpers) => {
    startLoading();
    try {
      // Simulate a sign-in process (Using for testing loading)
      // await new Promise((resolve) => setTimeout(resolve, 1000));

      const result = await signUp(values.name, values.email, values.phone);
      if (isMounted()) {
        if (result) {
          onSuccess();
        } else {
          onError(helpers, 'Response Error');
        }
      }
    } catch (err) {
      if (isMounted()) {
        onError(helpers, err.message);
      }
    } finally {
      stopLoading();
    }
  };

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit,
  });

  return {
    formik,
  };
};

export default useViewModel;
